export default (url, fileName) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
};



// WEBPACK FOOTER //
// ./src/utils/downloadFile.js